import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
  CODE22_LIST,
  CODE22_SEARCH_DISPENSING_UNIT_LIST,
  CODE22_DETAIL,
  CODE22_SEARCH_ATC5_LIST,
  CODE22_SEARCH_YEAR_LIST,
  CODE22_SEARCH_CODE22_TYPE_LIST,
  CODE22_SEARCH_DEMAND_LIST
} from '../actions';
import {
  Code22ListSuccess,
  Code22ListError,
  Code22SearchDispensingUnitListSuccess,
  Code22SearchDispensingUnitListError,
  Code22SearchAtc5ListSuccess,
  Code22SearchAtc5ListError,
  Code22SearchYearListSuccess,
  Code22SearchYearListError,
  Code22DetailSuccess,
  Code22DetailError,
  Code22SearchCode22TypeListSuccess,
  Code22SearchCode22TypeListError,
  Code22SearchDemandListSuccess,
  Code22SearchDemandListError
} from '../actions';

export function* watchCode22List() {
  yield takeEvery(CODE22_LIST, onCode22List);
}

export function* watchCode22SearchDispensingUnitList() {
  yield takeEvery(CODE22_SEARCH_DISPENSING_UNIT_LIST, onCode22SearchDispensingUnitList);
}

export function* watchCode22Detail() {
  yield takeEvery(CODE22_DETAIL, onCode22Detail);
}

export function* watchCode22SearchAtc5List() {
  yield takeEvery(CODE22_SEARCH_ATC5_LIST, onCode22SearchAtc5List);
}

export function* watchCode22SearchYearList() {
  yield takeEvery(CODE22_SEARCH_YEAR_LIST, onCode22SearchYearList);
}

export function* watchCode22SearchCode22TypeList() {
  yield takeEvery(CODE22_SEARCH_CODE22_TYPE_LIST, onCode22SearchCode22TypeList);
}

export function* watchCode22SearchDemandList() {
  yield takeEvery(CODE22_SEARCH_DEMAND_LIST, onCode22SearchDemandList);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onCode22ListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'code22/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onCode22SearchDispensingUnitListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/code22_group', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onCode22DetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'code22/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onCode22SearchAtc5ListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/atc5', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onCode22SearchYearListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/year', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onCode22SearchCode22TypeListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/code22_type', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onCode22SearchDemandListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/demand', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

function* onCode22List(data) {
  try {
    const response = yield call(onCode22ListAsync, data.payload);
    yield put(Code22ListSuccess(response.data));
  } catch (error) {
    yield put(Code22ListError(error));
  }
}

function* onCode22Detail(data) {
  try {
    const response = yield call(onCode22DetailAsync, data.payload);
    yield put(Code22DetailSuccess(response.data.data));
  } catch (error) {
    yield put(Code22DetailError(error));
  }
}


function* onCode22SearchDispensingUnitList(data) {
  try {
    const response = yield call(onCode22SearchDispensingUnitListAsync, data);
    yield put(Code22SearchDispensingUnitListSuccess(response.data));
  } catch (error) {
    yield put(Code22SearchDispensingUnitListError(error));
  }
}

function* onCode22SearchAtc5List(data) {
  try {
    const response = yield call(onCode22SearchAtc5ListAsync, data);
    yield put(Code22SearchAtc5ListSuccess(response.data));
  } catch (error) {
    yield put(Code22SearchAtc5ListError(error));
  }
}

function* onCode22SearchYearList(data) {
  try {
    const response = yield call(onCode22SearchYearListAsync, data);
    yield put(Code22SearchYearListSuccess(response.data));
  } catch (error) {
    yield put(Code22SearchYearListError(error));
  }
}

function* onCode22SearchCode22TypeList(data) {
  try {
    const response = yield call(onCode22SearchCode22TypeListAsync, data);
    yield put(Code22SearchCode22TypeListSuccess(response.data));
  } catch (error) {
    yield put(Code22SearchCode22TypeListError(error));
  }
}

function* onCode22SearchDemandList(data) {
  try {
    const response = yield call(onCode22SearchDemandListAsync, data);
    yield put(Code22SearchDemandListSuccess(response.data));
  } catch (error) {
    yield put(Code22SearchDemandListError(error));
  }
}
export default function* rootSaga() {
  yield all([
    fork(watchCode22List),
    fork(watchCode22SearchDispensingUnitList),
    fork(watchCode22SearchAtc5List),
    fork(watchCode22SearchYearList),
    fork(watchCode22Detail),
    fork(watchCode22SearchCode22TypeList),
    fork(watchCode22SearchDemandList)
  ]);
}